import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";

import { FormLinkBlock as Block } from "./FormLinkBlock";
import { defaultData } from "./FormLinkBlockDefaultData";
import { meta } from "./FormLinkBlockMetaData";

export const FormLinkBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-link",
    size: 24,
  },
  meta,
};
